import { ProductActionType } from "../action-types/productActionTypes";
import {
  UPDATE_PID,
  UPDATE_XY,
  UPDATE_TS,
  UPDATE_ACTIVE_TEST_ID,
  UPDATE_FIXATION_VALUE,
  UPDATE_WARNING,
  UPDATE_STATUS,
  UPDATE_BATTERY,
  UPDATE_CONTROLLERS,
  UPDATE_CONTROLLER_BATTERY,
  UPDATE_CONTROLLER_RECONNECT_PROMPT,
  UPDATE_CURRENT_VERSION,
  UPDATE_IS_EYE_TRACKING_ON,
  UPDATE_SCENE,
  UPDATE_ON_TEST_PROGRESS_PAGE,
  UPDATE_DEVICE_STATUS,
  UPDATE_PATIENT_ACTION,
  REQUEST_CONTROLLER_RECONNECT,
  UPDATE_VOLUME,
  CLEAR_TEST_PROGRESS,
  BATCH_UPDATE,
  RESET_PRODUCT_STATE as RESET_PRODUCT_STATE,
  UPDATE_PRODUCT_SCOPE,
  SET_LATEST_TEST_INTERACTION_DATE,
  CLEAR_AWAITING_MENU_SCENE,
} from "../constants";
import {
  ControllerBatteryState,
  ControllerConnectionState,
  HeadsetVersion,
} from "types/productTypes";

export const resetProductState = (): ProductActionType => ({
  type: RESET_PRODUCT_STATE,
});
export const updatePid = (payload: string): ProductActionType => ({ type: UPDATE_PID, payload });
export const updateXY = (payload: { x: number; y: number }): ProductActionType => ({
  type: UPDATE_XY,
  payload,
});
export const updateProductTs = (payload: number): ProductActionType => ({
  type: UPDATE_TS,
  payload,
});
export const updateActiveTestId = (payload: string): ProductActionType => ({
  type: UPDATE_ACTIVE_TEST_ID,
  payload,
});

export const updateFixationLossValue = (payload: string): ProductActionType => ({
  type: UPDATE_FIXATION_VALUE,
  payload,
});
export const updateWarning = (payload: number): ProductActionType => ({
  type: UPDATE_WARNING,
  payload,
});
export const updateStatus = (payload: number): ProductActionType => ({
  type: UPDATE_STATUS,
  payload,
});
export const updateBattery = (payload: number): ProductActionType => ({
  type: UPDATE_BATTERY,
  payload,
});
export const updateControllers = (
  payload: number | ControllerConnectionState | null,
): ProductActionType => ({
  type: UPDATE_CONTROLLERS,
  payload,
});
export const updateControllerBattery = (
  payload: ControllerBatteryState | null,
): ProductActionType => ({
  type: UPDATE_CONTROLLER_BATTERY,
  payload,
});
export const setControllerReconnectPromptVisible = (payload: boolean): ProductActionType => ({
  type: UPDATE_CONTROLLER_RECONNECT_PROMPT,
  payload,
});
export const requestControllerReconnect = (): ProductActionType => ({
  type: REQUEST_CONTROLLER_RECONNECT,
});
export const updateCurrentVersion = (payload: HeadsetVersion): ProductActionType => ({
  type: UPDATE_CURRENT_VERSION,
  payload,
});
export const updateIsEyeTrackingOn = (payload: boolean): ProductActionType => ({
  type: UPDATE_IS_EYE_TRACKING_ON,
  payload,
});
export const updateScene = (scene: string, lastInteraction: Date | null): ProductActionType => ({
  type: UPDATE_SCENE,
  payload: { scene, lastInteraction },
});
export const updateOnTestProgressPage = (payload: boolean): ProductActionType => ({
  type: UPDATE_ON_TEST_PROGRESS_PAGE,
  payload,
});
export const updateDeviceStatus = (payload: number): ProductActionType => ({
  type: UPDATE_DEVICE_STATUS,
  payload,
});
export const updatePatientAction = (payload: string): ProductActionType => ({
  type: UPDATE_PATIENT_ACTION,
  payload,
});
export const updateVolume = (payload: number): ProductActionType => ({
  type: UPDATE_VOLUME,
  payload,
});
export const clearTestProgress = (): ProductActionType => ({
  type: CLEAR_TEST_PROGRESS,
});

export const clearAwaitingMenuScene = (): ProductActionType => ({
  type: CLEAR_AWAITING_MENU_SCENE,
});

export const updateProductBatch = (payload: Record<string, any>): ProductActionType => ({
  type: BATCH_UPDATE,
  payload,
});

export const updateProductScope = (payload: string[]): ProductActionType => {
  if (!payload || payload.length === 0) {
    payload = ["newUI", "VFA"];
    return { type: UPDATE_PRODUCT_SCOPE, payload: payload };
  }

  // Otherwise, add "newUI" to the list
  return {
    type: UPDATE_PRODUCT_SCOPE,
    payload: payload.includes("newUI") ? payload : [...payload, "newUI"],
  };
};

export const setLatestTestInteractionDate = (payload: Date | null): ProductActionType => ({
  type: SET_LATEST_TEST_INTERACTION_DATE,
  payload,
});
